import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import { CONTENT_CHAR_LIMIT, APPROXIMATE_FILE_SIZE_LIMIT } from '../SourceMaterialModal'
import Styles from './CharacterLimitNote.module.scss'
import { Text } from 'blaze-ui/Text/Text'

export const CharacterLimitNote = () => {
  const isSystemRedesignEnabled = useIsSystemRedesign()

  if (isSystemRedesignEnabled) {
    return (
      <Text variant="metadata" color="var(--dark-40)">
        Source materials are automatically limited to {CONTENT_CHAR_LIMIT} characters or ~{APPROXIMATE_FILE_SIZE_LIMIT}{' '}
        KB.
      </Text>
    )
  }
  return (
    <p className={Styles.note}>
      Note: Source materials are automatically limited to {CONTENT_CHAR_LIMIT} characters or ~
      {APPROXIMATE_FILE_SIZE_LIMIT} KB.
    </p>
  )
}
